import styled from "styled-components";

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Line = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const Content = styled.div`
  display: flex;
  padding: 16px 16px 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  max-width: 212px;
`;

export const Wrapper = styled.div`
  display: flex;
  width: 181px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const Title = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const Value = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
`;